export function getLiveAtlToken(): string | null {
	// in SSR or non-browser contexts there is no document
	if (typeof document === 'undefined') return null;

	// try the meta tag first: <meta name="ajs-atl-token" content="...">
	// use a typed querySelector so .content is available on HTMLMetaElement
	const metaToken =
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		document.querySelector<HTMLMetaElement>('meta[name="ajs-atl-token"]')?.content ??
		// fallback to attribute read in case DOM typings differ
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		document.querySelector('meta[name="ajs-atl-token"]')?.getAttribute('content');
	if (metaToken) return metaToken;

	// fallback to cookies if readable in this environment
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const m = document.cookie.match(
		/(?:^|;\s*)(atl\.xsrf\.token|atlassian\.account\.xsrf\.token)=([^;]+)/,
	);

	// group 2 is the token value
	return m ? m[2] : null;
}

export function getPageId(path: string): string | null {
	const m = path.match(/\/pages\/(\d+)/);
	return m ? m[1] : null;
}

export function isPageViewRoute(path: string): boolean {
	// Manual pathname check instead of using VIEW_PAGE.match() to avoid circular dependency
	// Using @confluence/named-routes -> @confluence/view-page-common creates a circular dependency:
	// @confluence/content-renderer -> @confluence/pdf-export -> @confluence/view-page-common -> @confluence/content-renderer
	// Pattern matches: /spaces/:spaceKey/pages/:contentId(digits)/:contentSlug?
	return path.match(/\/spaces\/[^/]+\/pages\/\d+/) !== null;
}

export function isInsideIframe(): boolean {
	try {
		return window.self !== window.top;
	} catch (e) {
		// accessing window.top can throw in some cross-origin scenarios
		return true;
	}
}

export const preloadImage = (imagePath: string): void => {
	const img = new Image();
	img.src = imagePath;
};
